var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"webView",staticClass:"main-iframe",attrs:{"src":_vm.src,"id":"show-iframe","allowfullscreen":"","webkitallowfullscreen":"","mozallowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }